import React, {useEffect, useState} from 'react';
import { css } from "@emotion/core";
import locate from "../geo/locator";

let overlay = css`
  position: relative;
  top: 0;
  left: 0;
  padding: 16px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;

  @media (min-width: 768px) and (min-height: 700px) {
    position: absolute;
    left: 10%;
    width: 400px;
    height: 101%;
    padding-bottom: 56.25%;
  }
`;

let inner = css`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  @media (min-width: 768px) and (min-height: 700px) {
    top: 40px;
  }
`;

let branding = css`
  width: 100%;
  font-size: 35px;
  line-height: 1;
  display: flex;
  justify-content: left;
  align-items: center;

  @media (min-width: 768px) and (min-height: 700px) {
    font-size: 45px;
  }
`;

let logo = css`
  height: 25px;
  padding-right: 8px;

  @media (min-width: 769px) and (min-height: 700px) {
    height: 35px;
    padding-right: 16px;
  }
`;

let p = css`
  width: 100%;
  margin-top: 0.9375rem;
  margin-bottom: 0;
  text-align: left;
`;

let locateButton = css`
  margin: 1.875rem 0;
`;

export default function BlockScreen({ user, onLocate }) {
  let [blockState, setBlockState] = useState('INITIAL');
  let [locatorError, setLocatorError] = useState(null);
  let unknownLocation = user.city === 'unknown' || user.state === 'unknown';
  let browserGeoPossible = (blockState === 'INITIAL' || (blockState === 'GEO_ERROR' && locatorError !== 1)) &&
    typeof navigator !== 'undefined' &&
    navigator.geolocation;

  let locateHandler = e => {
    e.preventDefault();
    setBlockState('REQUESTING');
    locate()
      .then(onLocate)
      .then(() => setBlockState('COMPLETE'))
      .catch(err => {
        if (err instanceof window.GeolocationPositionError) {

          // See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError for error codes
          setLocatorError(err.code);
          setBlockState('GEO_ERROR');
        }

        setBlockState('OTHER_ERROR');
      });
  };

  return <div css={overlay}>
    <div css={inner}>
      <div css={branding}>
        <img css={logo} src={"/content/themes/tpt/dist/images/tpt-logo.svg"} alt={"TPT Livestream"} /> Livestream
      </div>
      <p css={p}>
        We are sorry for the inconvenience, but this content is only visible from within Minnesota.
      </p>
      {
        browserGeoPossible &&
        unknownLocation &&
        <p css={p}>
          Our system can not automatically determine your location.
        </p>
      }
      {
        browserGeoPossible &&
        !unknownLocation &&
        <p css={p}>
          Our system is currently showing you in the area of {user.city}, {user.state}
        </p>
      }
      {
        browserGeoPossible &&
        <p css={p}>
          {!unknownLocation && "Depending on your internet provider's location, we may have miscalculated."} Please click the button below,
          and confirm when prompted to allow Twin Cities PBS to use your browser's location.
        </p>
      }
      {
        browserGeoPossible &&
        <a css={locateButton} className="no-delay outline-btn" href="#" onClick={locateHandler}>Check Location</a>
      }
      {
        blockState === 'REQUESTING' &&
        <p css={p}>
          Requesting location...
        </p>
      }
      {
        locatorError === 1 &&
        <p css={p}>
          Your browser has denied the location request. For assistance <a href={"#"}>follow these instructions</a> or <a href={"/contact/"}>contact us</a>.
        </p>
      }
      {
        locatorError === 2 &&
        <p css={p}>
          Your browser was unable to determine your location. Please try again.
        </p>
      }
      {
        locatorError === 3 &&
        <p css={p}>
          We were not able to detect your location. Please try again.
        </p>
      }
    </div>
  </div>;
}